"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAddressApprovalStatusEnum = void 0;
var OrderAddressApprovalStatusEnum;
(function (OrderAddressApprovalStatusEnum) {
    OrderAddressApprovalStatusEnum["Approved"] = "APPROVED";
    OrderAddressApprovalStatusEnum["Rejected"] = "REJECTED";
})(OrderAddressApprovalStatusEnum || (exports.OrderAddressApprovalStatusEnum = OrderAddressApprovalStatusEnum = {}));
//# sourceMappingURL=order-address-approval-status.enum.js.map